import Api from "@/services/api";
import { WayfidnerSolution } from "@/services/wayfinder/types";

export async function getWayfinderSolutions(): Promise<Array<WayfidnerSolution>> {
    return new Promise((resolve, reject) => {
        Api.get(`/wayfinder`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
